module.exports = __webpack_public_path__ + "img/LogoExtend.57a72e85.png";